import type * as Types from '../../../../../graphql/generated-base';

import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@graphql/react-hooks';
export type HoneymoonCoupleAvatarsQueryVariables = Types.Exact<{
  name: Types.Scalars['String'];
}>;

export type HoneymoonCoupleAvatarsQuery = {
  __typename?: 'Query';
  eventByName?: {
    __typename?: 'Event';
    id: string;
    info: {
      __typename?: 'EventInfo';
      id: string;
      ownerFirstName?: string | null;
      ownerLastName?: string | null;
      fianceeFirstName?: string | null;
      fianceeLastName?: string | null;
    };
    eventUsers: Array<{
      __typename?: 'EventUser';
      id: string;
      status: Types.EventUserStatus;
      user: { __typename?: 'User'; id: string; firstName?: string | null; lastName?: string | null; avatar?: { __typename?: 'Photo'; id: string; url: string } | null };
    }>;
  } | null;
};

export const HoneymoonCoupleAvatarsDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'HoneymoonCoupleAvatars' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'name' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'eventByName' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'name' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'name' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'info' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ownerFirstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ownerLastName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fianceeFirstName' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fianceeLastName' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'eventUsers' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'user' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'avatar' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

/**
 * __useHoneymoonCoupleAvatarsQuery__
 *
 * To run a query within a React component, call `useHoneymoonCoupleAvatarsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHoneymoonCoupleAvatarsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHoneymoonCoupleAvatarsQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useHoneymoonCoupleAvatarsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<HoneymoonCoupleAvatarsQuery, HoneymoonCoupleAvatarsQueryVariables>) {
  return ApolloReactHooks.useQuery<HoneymoonCoupleAvatarsQuery, HoneymoonCoupleAvatarsQueryVariables>(HoneymoonCoupleAvatarsDocument, baseOptions);
}
export function useHoneymoonCoupleAvatarsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HoneymoonCoupleAvatarsQuery, HoneymoonCoupleAvatarsQueryVariables>) {
  return ApolloReactHooks.useLazyQuery<HoneymoonCoupleAvatarsQuery, HoneymoonCoupleAvatarsQueryVariables>(HoneymoonCoupleAvatarsDocument, baseOptions);
}
export type HoneymoonCoupleAvatarsQueryHookResult = ReturnType<typeof useHoneymoonCoupleAvatarsQuery>;
export type HoneymoonCoupleAvatarsLazyQueryHookResult = ReturnType<typeof useHoneymoonCoupleAvatarsLazyQuery>;
export type HoneymoonCoupleAvatarsQueryResult = Apollo.QueryResult<HoneymoonCoupleAvatarsQuery, HoneymoonCoupleAvatarsQueryVariables>;
